import { Card, Col, Row, Space } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ModuleType } from '../../../../api/types';
import ModuleSelectField from '../../../../components/fields/ModuleSelectField';
import MakeDetailsForm from '../../MakeDetailsPage/MakeDetailsForm';

const AddMakeForm = () => {
    const { t } = useTranslation('makeDetails');

    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Card title={t('makeDetails:cardTitles.selectModule')}>
                <Row gutter={14}>
                    <Col lg={8} xs={24}>
                        <ModuleSelectField
                            {...t('makeDetails:fields.module', { returnObjects: true })}
                            moduleType={ModuleType.SimpleVehicleManagement}
                            name="moduleId"
                            required
                        />
                    </Col>
                </Row>
            </Card>
            <MakeDetailsForm />
        </Space>
    );
};

export default AddMakeForm;
